export default {
  booking: {
    created_at: 'Created At',
  },
  created_at: 'Created At',
};
